import Box from '@mui/material/Box'
import { observer } from 'mobx-react-lite'
import useInitialMount from 'reusable/hooks/useInitialMount'
import useStore from 'reusable/mobx-store-utils'
import SkeletonLoader from 'reusable/mui/skeleton/SkeletonLoader'
import DevAITokensStore from './DevAITokensStore'

export default observer(function DevAITokens() {
   const devAITokensStore = useStore(() => new DevAITokensStore())

   useInitialMount(() => {
      devAITokensStore.fetch()
   })

   return <Box sx={{ p: 3 }}>
      <SkeletonLoader loading={devAITokensStore.loader.isLoading} sx={{ height: 'auto', width: '100%' }}>
         {devAITokensStore.tokenUsage.length && <>
            Total Bedrock token usage:
            <pre>
               {JSON.stringify(devAITokensStore.tokenUsage, null, 2)}
            </pre>
         </>}
         {!devAITokensStore.tokenUsage.length && <>
            No Bedrock token usage found.
         </>}
      </SkeletonLoader>
   </Box>
})
